import React, { Component } from 'react';
import _ws from '@netuno/ws-client';
import Core from '../../Core';
import numeral from 'numeral';

import "./index.less";

export default class Prices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prices: [],
      selectedPrice: {}
    };

    this.handleChangeSelectedPrice = this.handleChangeSelectedPrice.bind(this);
  }
  componentDidMount() {

    this.listenerGetPrices = _ws.addListener({
      service: 'remote/price',
      success: (res) => {
        this.setState({ prices: res.content });

        const metadata = Core.data().metadata;

        let selectedPrice = {};

        this.state.prices.forEach((price, index) => {

          if (price.from === Number(metadata.priceFrom)
            && price.to === Number(metadata.priceTo)) {
            selectedPrice = price;
          }
        });

        this.setState({ selectedPrice });

        console.log("selectedPrice");
        console.log(selectedPrice);

        this.props.addMetadata("priceFrom", Number(metadata.priceFrom));
        this.props.addMetadata("priceTo", Number(metadata.priceTo));
      },
      fail: (error) => {
        console.log(error);
      }
    });

    Core.getContext({
      onSuccess: () => {
        const metadata = Core.data().metadata;
        let typeCode = '';
        if (metadata.remontraPrincipal__menu === 'Comprar') {
          typeCode = 'sale';
        } else if (metadata.remontraPrincipal__menu === 'Arrendar') {
          typeCode = 'rent';
        }
        _ws.sendService({
          service: 'remote/price',
          data: {
            type_code: typeCode,
            city_uid: metadata.cityUid
          }
        });
      },
      onFail: (data) => {
        console.log("Context data failed.", data);
      }
    });

    _ws.sendService({
      service: 'ws/remote/command',
      data: {
        type: JSON.stringify({
          type: "prices",
          city_uid: "",
          price_min: "",
          price_max: "",
        })
      }
    });
  }

  componentWillUnmount() {
    _ws.removeListener(this.listenerGetPrices);
  }

  async handleChangeSelectedPrice(price) {
    /**let priceFrom = null;
    let priceTo = null;

    let selectedPrice = {};

    if (price.index != this.state.selectedPrice.index) {
      selectedPrice = price;
      priceFrom = price.from;
      priceTo = price.to;
    }*/

    const selectedPrice = price;
    const priceFrom = price.from;
    const priceTo = price.to;

    this.setState({ selectedPrice })

    this.props.addMetadata("priceFrom", priceFrom);
    const setMetadata = await this.props.addMetadata("priceTo", priceTo);

    if (setMetadata) {
      this.props.handleSubmit();
    }
  }

  render() {
    const { prices } = this.state;
    if (prices) {
      return (
        <div className="prices">
          {prices.map((price, index) => {
            return (
              price.to ? (
                <button
                  key={price.from + "-" + price.to}
                  onClick={() => {
                    price.index = index
                    this.handleChangeSelectedPrice(price)
                  }}
                  disabled={price.total > 0 ? false : true}
                >
                  <p>{numeral(price.from).format(
                    '0,0'
                  ).replace(",", ".")}&euro; »</p>
                  <p>{numeral(price.to).format(
                    '0,0'
                  ).replace(",", ".")}&euro;</p>
                  <p>({price.total} imóveis)</p>
                </button>
              ) : (
                <button
                  key={price.from + "-" + price.to}
                  onClick={() => {
                    price.index = index
                    this.handleChangeSelectedPrice(price)
                  }}
                  disabled={price.total > 0 ? false : true}
                >
                  <p>{numeral(price.from).format(
                    '0,0'
                  ).replace(",", ".")}&euro; ou mais</p>
                  <p>({price.total} imóveis)</p>
                </button>
              )
            );
          })}
        </div>
      );
    }
    return (
      <div>Houve uma falha ao carregar os preços, tente mais tarde.</div>
    );
  }
}
